module.exports = __webpack_public_path__ + "static/media/image 13.946307c3.png";